import React, {useState} from 'react';
import TermsofService from '../components/TermsofService'
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const TermsPage = () => {

  const[isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
    };

  return (
    <>
    <ScrollToTop />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <Navbar toggle={toggle} />
    <TermsofService />
    <Footer />
    </>
  )
}

export default TermsPage;
